import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnDestroy, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { Notifier } from '@core/services/notifier.service';
import { TranslateService } from '@devinforius/i-essentials';
import { PagesEndpoints } from '@shared/enums/pages-endpoints.enum';
import { HomesService } from '@shared/services/homes.service';
import { from, Subscription, switchMap, tap } from 'rxjs';

@Component({
  selector: 'im-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnDestroy {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly notifier = inject(Notifier);
  private readonly translater = inject(TranslateService);
  private readonly homesService = inject(HomesService);
  public areTradsReady = signal<boolean>(false);
  public supportContactDetails = {
    phoneNumber: '081 744 340',
    email: 'infodoc@inforius.be',
  };
  public redirecting = signal<boolean>(false);
  public validToken = signal<boolean>(true);
  private sub: Subscription | null = null;

  constructor() {
    if (this.auth.hasValidAccessToken) {
      this.sub = this.translater.onTranslationReady
        .pipe(
          tap((areReady) => this.areTradsReady.set(areReady)),
          switchMap(() => from(this.auth.loadUserProfile())),
          switchMap(() => this.auth.fetchUserInfos()),
        )
        .subscribe({
          next: (userInfos) => {
            this.auth.userInfos.set(userInfos);

            this.homesService.currentVisitedHome$.next(userInfos.home);
            this.auth.isConnected$.next(true);
            this.redirecting.set(true);

            const targetURL = JSON.parse(
              localStorage.getItem('targetURL') as string,
            );

            if (
              targetURL &&
              (targetURL as string).includes(userInfos.home.name)
            ) {
              this.router.navigateByUrl(targetURL).then(() => {
                this.redirecting.set(false);
                localStorage.removeItem('targetURL');
              });
            } else {
              this.router
                .navigateByUrl(
                  `/private/${this.homesService.currentVisitedHome$.value?.name}/${PagesEndpoints.Mandates}`,
                )
                .then(() => {
                  this.redirecting.set(false);
                });
            }
          },
          error: (err: HttpErrorResponse) => {
            if (err.status === 400) {
              this.notifier.showError('forbidden');
              this.validToken.set(false);
            }
          },
        });
    } else {
      this.sub = this.translater.onTranslationReady.subscribe((isReady) => {
        this.areTradsReady.set(isReady);
        setTimeout(() => {
          this.login();
        }, 2000);
      });
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
  public login(): void {
    this.auth.login();
  }

  public logout(): void {
    this.auth.logout();
  }
}
